<template>
  <v-card flat :class="{ 'grey--text': disabled }">
    <v-card-title class="card-bg-2 headline">
      <v-flex style="flex: 0 0 150px; align-items: baseline; display: flex;">
        Guidelines
        <v-menu v-model="showHelp" offset-y open-on-hover :open-delay="400">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" @click="showHelp = true" class="clickable ml-2" :color="isEmphasizeTooltip ? 'warning' : 'primary'">
              info_outline
            </v-icon>
          </template>
          <v-card>
            <v-card-text>
              <div class="mb-2">
                Available guidelines match at least one media type from all selected stations.
              </div>

              <div>
                <strong>Note:</strong> Only four guidelines may be shown in a report due to formatting limitations.
              </div>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-flex>
      <v-spacer />
      <v-text-field :disabled="disabled" class="rounded emphasize-clear" prepend-inner-icon="search" v-model="search" clearable solo placeholder="Search guidelines" hide-details>
      </v-text-field>
    </v-card-title>
    <div class="card-bg-2 default-border-bottom scroll-border-bottom">
      <v-item-group mandatory v-model="filterToggle" active-class="white--text">
        <v-subheader style="display: inline; cursor: default;">Show:</v-subheader>
        <v-item>
          <v-chip small slot-scope="{ active, toggle }" :color="active ? 'primary' : 'default'" :selected="active" class="chipFilter" @click="toggle">Available</v-chip>
        </v-item>
        <v-item>
          <v-chip small slot-scope="{ active, toggle }" :color="active ? 'primary' : 'default'" :selected="active" class="chipFilter" @click="toggle">
            <div style="float: left;" class="pr-2">
              <transition :name="atGuidelineLimit ? 'bounce' : ''" mode="out-in">
                <div v-if="atGuidelineLimit" :key="`max-guidelines-1`" class="warning--text font-weight-bold">
                  {{ guidelinesLength }} / {{ numMaxGuidelines }}
                </div>
                <div v-else :key="`max-guidelines-2`" :class="{ 'info--text font-weight-bold': guidelinesLength > 0 }">
                  {{ guidelinesLength }} / {{ numMaxGuidelines }}
                </div>
              </transition>
            </div>
            Selected
          </v-chip>
        </v-item>
      </v-item-group>
    </div>
    <v-card-text style="min-height: 225px; max-height: 225px; overflow: auto;" class="pa-0">
      <SelectGuidelines ref="selectGuidelines" :guidelines="guidelines" :disabled="disabled" @selected="onSelectedGuidelines" :selection="selection" :search="search" :filterToggle="filterToggle" :filterToggles="filterToggles" :selectionCount="guidelinesLength" :numMaxGuidelines="numMaxGuidelines" />
    </v-card-text>
  </v-card>
</template>

<script>
  import SelectGuidelines from './SelectGuidelines'

  const filterToggles = {
    available: 0,
    selected: 1,
  }

  export default {
    components: {
      SelectGuidelines,
    },
    props: {
      index: Number,
      disabled: Boolean,
      guidelines: Array,
      selection: Object,
    },
    data() {
      return {
        filterToggles,
        filterToggle: filterToggles.available,
        hasBeenEmphasized: false,
        isEmphasizeTooltip: false,
        numMaxGuidelines: 15,
        showHelp: false,
        selectedGuidelines: {},
        search: '',
        guidelinesLength: 0,
      }
    },
    computed: {
      atGuidelineLimit() {
        return this.guidelinesLength >= this.numMaxGuidelines
      },
    },
    watch: {
      atGuidelineLimit(val) {
        if (val) {
          this.emphasizeTooltip()
        }
      },
    },
    methods: {
      async emphasizeTooltip() {
        if (this.hasBeenEmphasized) return
        this.hasBeenEmphasized = true
        this.isEmphasizeTooltip = true

        setTimeout(() => {
          this.isEmphasizeTooltip = false
        }, 5000)
      },
      onSelectedGuidelines(value) {
        if (this.disabled) return
        this.selectedGuidelines = value
        let selectedGuidelines = (
          Object.values(value).flatten() // Flatten index by Category
          .map(group => Object.values(group)).flatten() // Flatten index by Id
        )

        this.guidelinesLength = selectedGuidelines.length

        let selectedMediaTypes = new Set()
        selectedGuidelines.forEach((guideline) => (
          guideline.MediaTypes.forEach(mediaType =>
            (selectedMediaTypes.add(mediaType))
          )
        ))

        this.$emit('guidelines', selectedGuidelines)
        this.$emit('mediaTypes', [...selectedMediaTypes])
      },
      onClose(id) {
        if (this.disabled) return
        this.$refs.selectGuidelines.toggleGuideline(id)
      },
      clearSearch() {
        this.search = ''
      },
      selectGuidelineIds(guidelineIds) {
        if (guidelineIds) this.filterToggle = this.filterToggles.selected
        if (!guidelineIds || guidelineIds.length == 0) this.filterToggle = this.filterToggles.available

        this.clearSearch()
        this.$refs.selectGuidelines.selectGuidelineIds(guidelineIds)
      },
    },
  }
</script>

<style scoped>
  .bounce-enter-active {
    animation: bounce-in .75s;
  }

  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }

    50% {
      transform: scale(1.25);
    }

    100% {
      transform: scale(.25);
    }
  }
</style>